import { Location, NgIf } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { ToolsAndEquipmentManualsService } from '../tools-and-equipment-manuals.service';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-tool-report-detail',
    templateUrl: './tool-report-detail.component.html',
    styleUrls: ['./tool-report-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, RouterLink],
})
export class ToolReportDetailComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscriptions: ISubscription[];
  public report: any;
  //public reportModels: any[];
  public reportSeries: any[];
  errorMessage = '';
  username: string;

  page: number;

  @ViewChild('toolReportContent')
  private toolReportContentDiv: ElementRef;

  constructor(
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private location: Location,
    private toolsAndEquipManualService: ToolsAndEquipmentManualsService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.username = this.authService.getUserName();
    const toolReportId = this.route.snapshot.paramMap.get('id');
    this.subscriptions = [];

    this.route.queryParams.subscribe(params => {
      this.page = parseInt(params['page']);
    });
    if (sessionStorage.getItem("savedToolReports")) {
      let allSavedToolReports = JSON.parse(sessionStorage.getItem("savedToolReports"));

      for (let i = 0; i < allSavedToolReports.length; i++) {
        if (allSavedToolReports[i].id == toolReportId) {
          this.report = allSavedToolReports[i];
          this.reportSeries = this.report['series'].map(series => series['seriesName']).join('/');
          break;
        }
      }
    } else {
      this.spinnerService.show('bmwSpinner');
      this.toolsAndEquipManualService.getReportInforById(toolReportId).subscribe(data => {
        this.spinnerService.hide('bmwSpinner');
        this.report = data;
        this.reportSeries = (this.report['series'] || []).map(series => series['seriesName']).join('/');
        this.cdr.markForCheck();


        this.toolsAndEquipManualService.addReportToUserHistory(this.username, this.report.id).subscribe(s => {
        }, error => {
          console.error('Error adding report to user hisstory', error);
        });

      }, error => {
        console.error('Error retrieving report info', error);
        this.spinnerService.hide('bmwSpinner');
        this.cdr.markForCheck();
      });
    }




  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  navigateBack() {
    //this.location.back();
    this.location.go('tool-report');
  }
  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }
  printBulletin(): void {
    let printContents, popupWindow, footerMessage;
    printContents = this.toolReportContentDiv.nativeElement.innerHTML;

    if (APP_SETTINGS.isBMW == 'true') {
      footerMessage = APP_SETTINGS.bmwCopyright;
    } else if (APP_SETTINGS.isMINI == 'true') {
      footerMessage = APP_SETTINGS.miniCopyright;
    } else if (APP_SETTINGS.isRollsRoyce == 'true') {
      footerMessage = APP_SETTINGS.rollsRoyceCopyright;
    } else {
      footerMessage = APP_SETTINGS.motorradCopyright;
    }

    popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWindow.document.open();
    const htmlContent = `
    <html>
      <head>
        <title>${this.report.documentTitle}</title>
        
        <style>
        body {
          font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
        }
        .bmw-lg-bulletin-section-header{
          font-weight: bold; 
          font-size: 18px;
        }
        .bmw-report-title {
          font-size: 36px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 30px;
        }
        .bmw-report-image {
          width: 315px;
          height: 236px;
        }
        .bmw-report-image img {
          width: 100%;
          height: 100%;
        }
        .bmw-report-notes-label {
          font-weight: bold;
          font-size: 16px;
          margin-top: 10px;
        }
        .bmw-report-notes {
          font-size: 16px;
        }
        .bmw-report-detail-label {
          font-weight: bold;
          font-size: 16px;
        }
        .bmw-report-detail {
          font-size: 16px;
          margin-bottom: 15px;
        }
        .bmw-report-details {
          margin-left: 5%;
        }
        .print-title{
          font-weight: bold;
          font-size: 24px;
          text-align: center;
          margin-bottom: 10px;
        }
        </style>
        <link rel="stylesheet" href="bulletin-detail.component.css">
        <link rel="stylesheet" href="../../../../assets/css/bootstrap.min.css">
      </head>
      <body onload="window.print();window.close()">

      <div style=" position: fixed;bottom: 0;
      width: 100%; 
      text-align: center;">${footerMessage}</div>

      <table style="width:100%">
      <tbody>
      <tr>
      <td >
      <div style="page-break-after: always;">
        ${printContents} <br />
        </div>
      </td>
      </tr>
      </tbody>
   <tfoot>
    <tr>
      <td>
      <div style="height: 20px;"></div>
    </td>
    </tr>
   </tfoot>
   </table>
    </body>
    </html>`;
    popupWindow.document.write(htmlContent);
    popupWindow.document.close();
  }
}
